import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';

import { BuildConfigService } from '../../services/build.config.service';

@Component({
  selector: 'dgx-pr-spa-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  year;

  constructor(public readonly buildConfigService: BuildConfigService) {
    this.year = new Date().getFullYear();
  }

  /**
   * Emits a click event back to the parent component
   */
  @Output() clicked: EventEmitter<void> = new EventEmitter();

  /**
   * Environment specific links
   */
  links = this.buildConfigService.config?.footer?.links;

  /**
   * Listens and fires an emit when link is clicked
   */
  onClick() {
    this.clicked.emit();
  }
}
